import OProjectWrapper from './o-project-wrapper.vue'

export default OProjectWrapper
